import { useTranslation } from 'react-i18next'

import { ChatText } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SubReasonsChip = ({ subReasons }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  if (!subReasons?.length) return null

  const getLabel = () => {
    if (subReasons?.length === 1) {
      return t('1 submotivo')
    }

    return t('{{length}} submotivos', { length: subReasons?.length })
  }

  return (
    <Chip
      backgroundColor={theme.colors.warning.surface}
      color={theme.colors.warning.onSurface}
      label={t(getLabel())}
      Icon={ChatText}
      tooltipContent={
        <Styles.TooltipListContainer>
          {subReasons.map(subReason => (
            <li key={subReason.id}>
              <Text type="bodySRegular">&quot;{subReason.display[i18n.language]}&quot;</Text>
            </li>
          ))}
        </Styles.TooltipListContainer>
      }
    />
  )
}

export default SubReasonsChip
